var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"breadcrumbs"}},[(_vm.ndc.broader)?_c('ul',[(_vm.ndc.broader)?_c('li',[_c('router-link',{attrs:{"to":{ path: _vm.ndc.broader.id }}},[_vm._v("\n        ← "+_vm._s(_vm.notation(_vm.ndc.broader.id))+" "+_vm._s(_vm.ndc.broader.label)+"\n      ")])],1):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4116d2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb.vue
// module id = null
// module chunks = 